window.$attributes = $('[data-product-attributes]');
window.variants = {
  $wrapperProduct: $(store.config.selectorWrapperProduct),
  config: {
    // pega o elemento que corresponde ao primeiro atributo
    $attr1: '',
    attr1Name: '',
    // pega o elemento que corresponde ao segundo atributo
    $attr2: '',
    attr2Name: '',
    // pega o elemento que corresponde ao terceiro atributo
    $attr3: '',
    attr3Name: '',
    // quantos atributos o produto tem para seleção
    qtdAttributes: 0,
    hasAttribute1: false,
    hasAttribute2: false,
    hasAttribute3: false,
  },
  setConfigDefault: function () {
    var _this = this;

    var $attr1 = $attributes.find('[data-attribute="1"]:not(.hidden)');
    var $attr2 = $attributes.find('[data-attribute="2"]:not(.hidden)');
    var $attr3 = $attributes.find('[data-attribute="3"]:not(.hidden)');

    var itensAttr1 = '';
    var itensAttr2 = '';
    var itensAttr3 = '';

    if ($attr1.length > 0) {
      itensAttr1 = $attr1.data('items');
      itensAttr1 = itensAttr1.split(' // ');
    }

    if ($attr2.length > 0) {
      itensAttr2 = $attr2.data('items');
      itensAttr2 = itensAttr2.split(' // ');
    }

    if ($attr3.length > 0) {
      itensAttr3 = $attr3.data('items') + '';
      itensAttr3 = itensAttr3.split(' // ');
    }

    $.extend(true, _this.config, {
      // pega o elemento que corresponde ao primeiro atributo
      $attr1: $attr1,
      attr1Name: $attr1.data('attribute-name'),
      itemsAttr1: itensAttr1,
      // pega o elemento que corresponde ao segundo atributo
      $attr2: $attr2,
      attr2Name: $attr2.data('attribute-name'),
      itemsAttr2: itensAttr2,
      // pega o elemento que corresponde ao terceiro atributo
      $attr3: $attr3,
      attr3Name: $attr3.data('attribute-name'),
      itemsAttr3: itensAttr3,
    });
  },
  setQtdAttributes: function () {
    // Seta quantos atributos o produto possuí para seleção

    var qtdAttributes = 0;

    var $input = $attributes.find('[data-quantidade-atributos]');

    var $attr1 = this.config.$attr1;
    var $attr2 = this.config.$attr2;
    var $attr3 = this.config.$attr3;

    // considerando que o tamanho é o primeiro atributo
    if ($attr1.length > 0) {
      qtdAttributes++;
      this.config.hasAttribute1 = true;
    }

    // considerando que a cor é o segundo atributo
    if ($attr2.length > 0) {
      qtdAttributes++;
      this.config.hasAttribute2 = true;
    }

    // considerando que o custom é o terceiro atributo
    if ($attr3.length > 0) {
      qtdAttributes++;
      this.config.hasAttribute3 = true;
    }

    this.config.qtdAttributes = qtdAttributes;
  },
  setDisponibility: function () {
    var _this = this;
    // console.info('setDisponibility');
    // console.info(_this.config);

    if (_this.config.qtdAttributes > 1) {
      // Para quando há o atributo 1 e o atributo 2
      if (_this.config.hasAttribute1 && _this.config.hasAttribute2) {
        // Itera todas os tamanhos para verificar a disponibilidade
        for (var i = 0; i < _this.config.itemsAttr1.length; i++) {
          var tamanho = _this.config.itemsAttr1[i];
          var $tamanho = _this.config.$attr1.find('[data-attribute-value="' + tamanho + '"]');
          var objFind = {};
          var tamanhoAvailable = false;
          objFind[_this.config.attr1Name] = tamanho;

          // Busca todas as variações que contém o tamanho
          var results = vnda.variants.find(objFind);

          // Percorre todas as variantes com o tamanho
          for (var ii = 0; ii < results.length; ii++) {
            // Verifica se alguma variação tem o tamanho
            if (results[ii].available) {
              corAvailable = true;
            }
          }

          $tamanho.data('available', tamanhoAvailable);
          $tamanho.attr('data-available', tamanhoAvailable);

          if (tamanhoAvailable) {
            $tamanho.removeClass('unavailable');
            $tamanho.addClass('available');
          } else {
            $tamanho.removeClass('available');
            $tamanho.addClass('unavailable');
          }
        }
      }
    }
  },
  toggleOptionsStyle: function (_$option) {
    /*
      Define se o estilo do atributo passado por parametro é input ou dropdown
    */
    var selecao = _$option.data('selecao');
    var styleType = _$option.data('selecao-style');
    var $optionList = _$option.find('[data-attribute-value]');
    var show = true;
    var showStatusList = [];

    // console.info('atributo', selecao, styleType);

    $optionList.each(function (index, el) {
      var value = $(el).data('attribute-value');

      // console.info(value, value.length);
      if (selecao != 'cor') {
        if (value.length > 4) {
          showStatusList[index] = true;
        } else {
          showStatusList[index] = false;
        }
      } else {
        if (value.indexOf('#') < 0) {
          showStatusList[index] = true;
        } else {
          showStatusList[index] = false;
        }
      }
    });

    if (showStatusList.indexOf(true) >= 0) {
      if (styleType == 'input') {
        show = false;
      } else if (styleType == 'dropdown') {
        show = true;
      }
    } else {
      if (styleType == 'input') {
        show = true;
      } else if (styleType == 'dropdown') {
        show = false;
      }
    }

    if (!show) {
      _$option.addClass('hidden');
    }
  },
  setAttributeValue: function (_value, _$attribute) {
    // console.info('setAttributeValue', _value, _$attribute);

    var attrName = _$attribute.data('attribute-name');
    var $input = _$attribute.find('input[data-attribute-name="' + attrName + '"]');

    $input.val(_value);
  },
  setAttributeValueSelected: function (_value, _$attribute) {
    // console.info('setAttributeValueSelected', _value, _$attribute);

    var $selected = _$attribute.find('[data-selected]');
    $selected.html(_value);
  },
  markFirstOption: function () {
    var _this = this;

    var $attr1 = this.config.$attr1;
    var $attr2 = this.config.$attr2;
    var $attr3 = this.config.$attr3;

    // console.log($attr1.find('[data-attribute-value][data-available=true]').first());
    // console.log($attr2.find('[data-attribute-value][data-available=true]').first());
    // console.log($attr3.find('[data-attribute-value][data-available=true]').first());
    // console.log('ATRIBUTO EXTRAAAQ',$attributes.find('[data-attribute-extra="sem-selecao"]'));

    // atributo com dropdown
    if ($attr1.find('[data-attribute-value][data-available=true]').first().length > 0) {
      $attr1.find('[data-attribute-value][data-available=true]').first().trigger('click');
    } else {
      $attr1.find('[data-attribute-value]').first().trigger('click');
    }

    if ($attr2.find('[data-attribute-value][data-available=true]').first().length > 0) {
      $attr2.find('[data-attribute-value][data-available=true]').first().trigger('click');
    } else {
      $attr2.find('[data-attribute-value]').first().trigger('click');
    }
    if ($attributes.find('[data-attribute-extra="sem-selecao"]').length > 0) {
      $attributes.find('[data-attribute-extra="sem-selecao"]').trigger('click')
    }
    

    /*if ($attr3.find('[data-attribute-value][data-available=true]').first().length > 0) {
      $attr3.find('[data-attribute-value][data-available=true]').first().trigger('click');
    } else {
      $attr3.find('[data-attribute-value]').first().trigger('click');
    } */
  },
  checkFirstAttribute: function () {
    var attributes = variants.config.itemsAttr1;
    for (var i = 0; i < attributes.length; i++) {
      var attribute = attributes[i];
      var attrSize = $('[data-attribute-value="' + attribute + '"]');
      var obj = {};

      obj[variants.config.attr1Name] = String(attribute);
      var results = vnda.variants.find(obj);
      var available = results.some((el) => el.available);

      if (available) {
        attrSize.data('available', true);
        attrSize.attr('data-available', true);

        attrSize.removeClass('unavailable');
        attrSize.addClass('available');
      } else {
        attrSize.data('available', false);
        attrSize.attr('data-available', false);

        attrSize.removeClass('available');
        attrSize.addClass('unavailable');
      }
    }
  },
  getSkuAttributes: function () {
    var _this = this;
    var objFindVariant = {};
    var objVariant;

    if (_this.config.hasAttribute1) {
      var nameAttr1 = _this.config.attr1Name;
      var valueAttr1 = _this.config.$attr1
        .find('input[data-attribute-name="' + nameAttr1 + '"]')
        .val();
      objFindVariant[nameAttr1] = valueAttr1;
    }

    if (_this.config.hasAttribute2) {
      var nameAttr2 = _this.config.attr2Name;
      var valueAttr2 = _this.config.$attr2
        .find('input[data-attribute-name="' + nameAttr2 + '"]')
        .val();
      objFindVariant[nameAttr2] = valueAttr2;
    }

    if (_this.config.hasAttribute3) {
      var nameAttr3 = _this.config.attr3Name;
      var valueAttr3 = _this.config.$attr3
        .find('input[data-attribute-name="' + nameAttr3 + '"]')
        .val();
      objFindVariant[nameAttr3] = valueAttr3;
    }

    objVariant = vnda.variants.find(objFindVariant);

    // // console.info('objFindVariant', objFindVariant);
    // // console.info('objVariant', objVariant);

    return objVariant;
  },
  updatePrice: function (sale_price, price, installments = [], customizationTotal = 0, norepeat = false) {
    const priceEl = document.querySelector('[data-section-product] [data-update-price]');
    

    // PREÇO = Gera o HTML correto caso tenha promoção (considera attr personalizado)
    let htmlPrice = '';

    if (sale_price != price) {
      htmlPrice = `
        <del>${store.formatMoney(price) + customizationTotal}</del>
        <ins>${store.formatMoney(sale_price + customizationTotal)}</ins>
      `;
    } else {
      htmlPrice = store.formatMoney(price + customizationTotal);
    }

    priceEl.innerHTML = htmlPrice;

    // Atualiza os atributos que salvam o último preço ativo
    priceEl.setAttribute('data-current-price', price);
    priceEl.setAttribute('data-sale-price', sale_price);

    // Evita loop infinito ao buscar personalização ativa.
    // norepeat vem como true somente de checkPersonalizationsPrice
    if (!norepeat) variants.checkPersonalizationsPrice();

    // Chama atualização de parcelas
    variants.updateInstallments(installments, customizationTotal);
  },
  updateInstallments: function(installments = [], customizationTotal = 0) {

    // Atualiza as parcelas novas antes de seguir com o cálculo
    if (installments.length > 0) {
      variants.config.installments = installments;
    }

    // Calcula o valor da parcela somando a customização
    const configInstallments = this.config.installments;

    const parcels = configInstallments.length;
    const totalPriceParcels = configInstallments[configInstallments.length - 1].total;
    let parcelPrice = configInstallments[configInstallments.length - 1].price;

    if (customizationTotal > 0) {
      let totalPrice = totalPriceParcels + customizationTotal;
      parcelPrice = totalPrice / parcels;
    }

    const installmentsEl = document.querySelector('[data-section-product] [data-update-installments]');
    if(installmentsEl != null) {
      installmentsEl.innerHTML = `em ${parcels}x de ${store.formatMoney(parcelPrice)}`
    }
    
  },
  checkPersonalizationsPrice: function() {
    // Verifica por personalizações que possam alterar o preço
    const personalizations = [...document.querySelectorAll('[data-customization-price]')];
    let activePersonalizations = [];
    if (personalizations.length > 0) {

      activePersonalizations = personalizations.filter(item => { return item.checked });

      // Se tem personalização selecionada, verifica se alguma tem valor para adicionar
      if (activePersonalizations.length > 0) {
        const priceEl = document.querySelector('[data-section-product] [data-update-price]');
        const productPrice = Number(priceEl.getAttribute('data-current-price'));
        const salePrice = Number(priceEl.getAttribute('data-sale-price'))
        let customPrice = 0;
        let hasChanged = false;

        // Realiza a soma dos valores
        activePersonalizations.forEach(item => {
          const value = Number(item.getAttribute('data-customization-price'));
          if (value > 0) { customPrice += value }
        })

        // Chama atualização de valores
        variants.updatePrice(salePrice, productPrice, [], customPrice, true);
      }
    }
  },
  // COMPORTAMENTO DE QUANDO O USUÁRIO SELECIONA UM ATRIBUTO
  setResultVariants: function () {
    var _this = this;
    // busca a variante
    var objVariant = _this.getSkuAttributes();

    // console.info('objVariant', objVariant);

    if (objVariant.length > 0) {
      // seta o sku da variante que o usuário selecionou
      _this.$wrapperProduct.find('input[name="sku"]').val(objVariant[0].sku);

      // atualiza o preço do produto conforme a variante selecionada
      _this.updatePrice(objVariant[0].sale_price, objVariant[0].price, objVariant[0].installments);

      if ($('[data-form-notify]').length > 0) {
        $('[data-form-notify] input[name="sku"]').val(objVariant[0].sku);
      }

      // verifica se a variante selecionada está disponível ou não
      if (!objVariant[0].available) {
        _this.setProdutoIndisponivel(objVariant[0]);
      } else {
        _this.setProdutoDisponivel(objVariant[0]);
      }
    } else {
      _this.setProdutoIndisponivel(objVariant[0]);
    }

    if (objVariant.length > 0) {
      $attributes.find('[data-variant-selected]').html(objVariant[0].name);

      // PARA AS IMAGENS
      _this.setImagesProduct(objVariant[0].sku);
    }
  },
  setProdutoIndisponivel: function (_variant) {
    var _this = this;
    var $btnComprar = _this.$wrapperProduct.find(store.config.selectorBtnBuy);
    var textUnavailable = $btnComprar.data('text-unavailable');

    $btnComprar.data('available', 'false');
    $btnComprar.removeClass('available');
    $btnComprar.addClass('unavailable');
    $btnComprar.html(textUnavailable);

    // AVISE-ME QUANDO CHEGAR AQUI
    if (_variant) {
      _this.setFormNotify(_variant);
    }
  },
  setFormNotify: function (_variant) {
    var height = $('[data-form-notify]').find('.form-wrapper').outerHeight(true);

    $('[data-form-notify]').addClass('active').css('height', height);

    setTimeout(function () {
      $(document.body).trigger('sticky_kit:recalc');
    }, 500);

    if ($('[data-form-notify]').length > 0) {
      $('[data-form-notify] input[name="sku"]').val(_variant.sku);
    }
  },
  checkCombinations: function (_value, _attributeName) {
    var _this = this;
    var obj = {};
    obj[_attributeName] = String(_value);
    var results = vnda.variants.find(obj);

    // console.info('checkCombinations', _attributeName, _value);
    // console.info('results combinations', results);

    // Verifica a disponibilidade das cores quando um tamanho é selecionado
    if (_this.config.attr1Name == _attributeName) {
      var cores = _this.config.itemsAttr2;
      var objFind = {};
      objFind[_attributeName] = String(_value);

      for (var i = 0; i < cores.length; i++) {
        objFind[_this.config.attr2Name] = String(cores[i]);
        var corTamanhoResults = vnda.variants.find(objFind);

        var cor = cores[i];
        var $cor = $('[data-attribute-value="' + cor + '"]');

        // console.info('corTamanhoResults', corTamanhoResults);

        if (corTamanhoResults.length > 0) {
          var available = corTamanhoResults.some((el) => el.available);

          $cor.removeClass('disable');

          if (available) {
            $cor.data('available', true);
            $cor.attr('data-available', true);

            $cor.removeClass('unavailable');
            $cor.addClass('available');
          } else {
            $cor.data('available', false);
            $cor.attr('data-available', false);

            $cor.removeClass('available');
            $cor.addClass('unavailable');
          }
        } else {
          $cor.addClass('disable');
        }
      }
    }

    // verifica a disponibilidade do terceiro atributo quando o segundo é selecionado
    else if (_this.config.attr2Name == _attributeName) {
      var itemsAttr3 = _this.config.itemsAttr3;
      var objFind = {};
      objFind[_this.config.attr1Name] = String(
        $(`[name="attribute-${_this.config.attr1Name}"]:checked`).val()
      );
      objFind[_this.config.attr2Name] = String(_value);

      // console.log('objFind', objFind)

      for (var i = 0; i < itemsAttr3.length; i++) {
        objFind[_this.config.attr3Name] = String(itemsAttr3[i]);
        var AllAttrResults = vnda.variants.find(objFind);

        var selected = itemsAttr3[i];
        var $attr3El = $('[data-attribute-value="' + selected + '"]');

        // console.info('AllAttrResults', AllAttrResults);

        if (AllAttrResults.length > 0) {
          var variantResult = AllAttrResults[0];

          $attr3El.removeClass('disable');

          if (variantResult.available) {
            $attr3El.data('available', true);
            $attr3El.attr('data-available', true);

            $attr3El.removeClass('unavailable');
            $attr3El.addClass('available');
          } else {
            $attr3El.data('available', false);
            $attr3El.attr('data-available', false);

            $attr3El.removeClass('available');
            $attr3El.addClass('unavailable');
          }
        } else {
          $attr3El.addClass('disable');
        }
      }
    }
  },
  setProdutoDisponivel: function () {
    var _this = this;
    var $btnComprar = _this.$wrapperProduct.find(store.config.selectorBtnBuy);
    var textAvailable = $btnComprar.data('text-available');

    $btnComprar.data('available', 'true');
    $btnComprar.removeClass('unavailable');
    $btnComprar.addClass('available');
    $btnComprar.html(textAvailable);

    $('[data-form-notify]').removeClass('active').css('height', 0);
  },
  /* 
    Exibe as imagens que contém o sku passado por parâmetro
  */
  setImagesProduct: function (_sku) {
    var $images = template_store.product.$wrapperImages;
    var $mainImages = template_store.product.$sliderProduct;
    var $thumbsImages = template_store.product.$thumbsProduct;
    var slideProduct = template_store.product.sliderProduct[0];
    var slideThumbs = template_store.product.sliderProduct[1];
    var qtdImagesSku = $mainImages.find('[data-skus-image*="' + _sku + ',"]').length;
    var $imagesWithoutSkus = $mainImages.find('.image-without-sku');
    var $thumbsWithoutSkus = $thumbsImages.find('.image-without-sku');

    // console.info($mainImages.find('[data-skus-image*="' + _sku + ',"]'));
    // console.info('[data-skus-image*="' + _sku + '"]');

    if (qtdImagesSku > 0) {
      // Esconde as imagens que não contém o sku
      $mainImages.find('[data-image][data-skus-image]').removeClass('active').addClass('inactive');

      $thumbsImages
        .find('[data-image-thumb][data-skus-image]')
        .removeClass('active')
        .addClass('inactive');

      // Mostra as imagens que contém o sku
      $mainImages
        .find('[data-image][data-skus-image*="' + _sku + ',"]')
        .addClass('active')
        .removeClass('inactive');

      $thumbsImages
        .find('[data-image-thumb][data-skus-image*="' + _sku + ',"]')
        .addClass('active')
        .removeClass('inactive');

      // As imagens sem skus selecionados são exibidas sempre
      $imagesWithoutSkus.removeClass('inactive').addClass('active');

      $thumbsWithoutSkus.removeClass('inactive').addClass('active');

      // $(document.body).trigger("sticky_kit:recalc");
      // console.log(slideProduct);
      slideProduct.update();
      slideThumbs.update();
      slideProduct.slideTo(0);
    } else {
      $mainImages.find('[data-image][data-skus-image]').removeClass('active').addClass('inactive');

      $thumbsImages
        .find('[data-image-thumb][data-skus-image]')
        .removeClass('active')
        .addClass('inactive');

      $imagesWithoutSkus.removeClass('inactive').addClass('active');

      $thumbsWithoutSkus.removeClass('inactive').addClass('active');
    }
  },
  execActionAttr: function (_attrName, _valueSelected) {
    var _this = this;

    if (_this.config.attr1Name == _attrName) {
      if (typeof attr1Action == 'function') {
        attr1Action(_valueSelected);
      }
    } else if (_this.config.attr2Name == _attrName) {
      if (typeof attr2Action == 'function') {
        attr2Action(_valueSelected);
      }
    } else if (_this.config.attr3Name == _attrName) {
      if (typeof attr3Action == 'function') {
        attr3Action(_valueSelected);
      }
    }
  },
  init: function () {
    var _this = this;

    // DEFINE SE O QUE VAI APARECER É A OPÇÃO EM INPUT RADIO OU O DROPDOWN
    $attributes.find('[data-prod-option]').each(function (index, el) {
      // _this.toggleOptionsStyle($(el));
    });

    $attributes.on(
      'click',
      '[data-prod-option]:not(.hidden) [data-attribute-value]',
      function (event) {
        if ($(this).is('a')) {
          event.preventDefault();
        }

        var $wrapperAttribute = $(this).closest('[data-prod-option]');

        var selecao = $wrapperAttribute.data('selecao');
        var selecaoStyle = $wrapperAttribute.data('selecao-style');
        var attrName = $wrapperAttribute.data('attribute-name');
        var value = $(this).data('attribute-value');

        // console.info('selecao value', selecao, attrName, value);

        _this.setAttributeValue(value, $wrapperAttribute);
        _this.setAttributeValueSelected(value, $wrapperAttribute);

        _this.checkCombinations(value, attrName);
        _this.execActionAttr(attrName, value);

        _this.setResultVariants();
      }
    );

    const personalizations = document.querySelectorAll('[data-customization-price]');
    if (personalizations.length > 0) personalizations.forEach(item => {
      item.addEventListener('change', _this.checkPersonalizationsPrice)
    })

    if (_this.qtdAttributes == 0) {
      var variant = vnda.variants.all()[0];

      if (!variant.available) {
        _this.setProdutoIndisponivel(variant);
      } else {
        _this.setProdutoDisponivel(variant);
      }
    }

    _this.setConfigDefault();
    _this.setQtdAttributes();
    _this.setDisponibility();
    _this.checkFirstAttribute();
    _this.markFirstOption();
  },
};

function attr1Action(_valueSelected) {
  var $attr1 = variants.config.$attr1;
  var $attr2 = variants.config.$attr2;
  var $attr3 = variants.config.$attr3;

  // console.log($attr1.find('[data-attribute-value][data-available=true]').first());
  // console.log($attr2.find('[data-attribute-value][data-available=true]').first());
  // console.log($attr3.find('[data-attribute-value][data-available=true]').first());

  if ($attr2.find('[data-attribute-value][data-available=true]:not(.disable)').first().length > 0) {
    //console.log('THIS', $attr2.find('[data-attribute-value][data-available=true]:not(.disable)').first())
    $attr2
      .find('[data-attribute-value][data-available=true]:not(.disable)')
      .first()
      .trigger('click');
  } else if ($attr2.find('[data-attribute-value][data-available=true]').first().length > 0) {
    $attr2.find('[data-attribute-value][data-available=true]').first().trigger('click');
  } else {
    $attr2.find('[data-attribute-value]').first().trigger('click');
  }
}

function attr2Action(_valueSelected) {
  var $attr1 = variants.config.$attr1;
  var $attr2 = variants.config.$attr2;
  var $attr3 = variants.config.$attr3;

  // console.log($attr1.find('[data-attribute-value][data-available=true]').first());
  // console.log($attr2.find('[data-attribute-value][data-available=true]').first());
  // console.log($attr3.find('[data-attribute-value][data-available=true]').first());

  if ($attr3.find('[data-attribute-value][data-available=true]:not(.disable)').first().length > 0) {
    //console.log('THIS', $attr3.find('[data-attribute-value][data-available=true]:not(.disable)').first())
    $attr3
      .find('[data-attribute-value][data-available=true]:not(.disable)')
      .first()
      .trigger('click');
  } else if ($attr3.find('[data-attribute-value][data-available=true]').first().length > 0) {
    $attr3.find('[data-attribute-value][data-available=true]').first().trigger('click');
  } else {
    $attr3.find('[data-attribute-value]').first().trigger('click');
  }
}

window.addEventListener('DOMContentLoaded', () => {
  if (page == 'product') {
    variants.init();
  }
});
